import { render, staticRenderFns } from "./categories-filter.vue?vue&type=template&id=9a06749c"
import script from "./categories-filter.vue?vue&type=script&lang=js"
export * from "./categories-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports